const StringHelper = {
  isEmpty: text => {
    return !StringHelper.isNotEmpty(text);
  },

  isNotEmpty: text => {
    return (
      typeof text !== 'undefined' &&
      text !== undefined &&
      text !== null &&
      text.toString().trim() !== ''
    );
  },

  onlyNumbers: text => {
    return text.replace(/([^\d]+)/gi, '');
  },
};

export default StringHelper;
